"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptwAileMaliyetiSchema = exports.ptwMaliyetAilesiSchema = exports.PTW_MALIYET_AILELERI = exports.KISI_EKSIK_SAGLIK_KOVALARI = exports.KISI_EKSIK_ETIKETI = exports.kisiEksikSchema = exports.KISI_EKSIKLERI = void 0;
exports.kisiEksikleri = kisiEksikleri;
exports.ptwMaliyetAilesiMi = ptwMaliyetAilesiMi;
exports.aileMaliyetMetni = aileMaliyetMetni;
const zod_1 = require("zod");
const ptw_kontrol_matrisi_1 = require("./ptw-kontrol-matrisi");
/**
 * MADDE 248 — K-248 (15.09.2026): KİŞİ EKSİKLERİ.
 *
 * Kontrol matrisi dört aile olarak kalır; *kayıt yok* kalemleri için ikinci
 * düzey düğme AÇILMAZ. Yerine iki yüzey bu sözlüğü okur:
 *   (a) aile açılmadan önce MALİYET ÖZETİ (kontrol matrisi),
 *   (b) Çalışanlar listesinde EKSİK SÜZGECİ.
 *
 * ⚠️ TEK KAYNAK — KOVA MOTORUN KALEM KODUNDAN TÜRER. "Temel İSG kaydı var mı"
 * ya da "kanaat süresi doldu mu" burada HESAPLANMAZ: `@isg/db
 * kisiEksikDurumlariTx` uygunluk motorunun kendi yüklemlerini (`kisiKalemleri`
 * · `saglikUygunMu`) çağırır ve yalnız çıkan KODU buraya verir. İkinci bir
 * hesap yazılsaydı panel, süzgeç ve izin kapısı üç ayrı sayı söylerdi.
 *
 * ⚠️ Kapsam dışı: `yetkinlik_istihdam_oncesi` · `yetkinlik_henuz_gecerli_degil`
 * · `saglik_uygun_degil` · `saglik_kisiti` — bunlar *kayıt yok* değil, kaydın
 * söylediği sonuçtur (veri girişiyle kapanmaz).
 */
exports.KISI_EKSIKLERI = ['saglik_kaydi_yok', 'temel_isg_yok', 'suresi_dolmus'];
exports.kisiEksikSchema = zod_1.z.enum(exports.KISI_EKSIKLERI);
exports.KISI_EKSIK_ETIKETI = {
    saglik_kaydi_yok: 'Sağlık kaydı yok',
    temel_isg_yok: 'Temel İSG yok',
    suresi_dolmus: 'Süresi dolmuş',
};
/** Sağlık verisi okuyan eksikler — süzgeçte sağlık okuma sınırına tabidir (§2.3). */
exports.KISI_EKSIK_SAGLIK_KOVALARI = ['saglik_kaydi_yok'];
/**
 * Kalem kodlarından eksik kovaları. `saglikDahil = false` iken sağlık kolu
 * hiç okunmaz — sağlık okuma sınırı dışındaki şapka için *süresi dolmuş*
 * yalnız temel İSG vadesidir.
 */
function kisiEksikleri(kodlar, saglikDahil = true) {
    const eksikler = new Set();
    if (kodlar.temelIsg === 'temel_isg_egitimi_yok')
        eksikler.add('temel_isg_yok');
    if (kodlar.temelIsg === 'yetkinlik_suresi_doldu')
        eksikler.add('suresi_dolmus');
    if (saglikDahil) {
        if (kodlar.saglik === 'saglik_kanaati_yok')
            eksikler.add('saglik_kaydi_yok');
        if (kodlar.saglik === 'saglik_kanaati_suresi_doldu')
            eksikler.add('suresi_dolmus');
    }
    return exports.KISI_EKSIKLERI.filter((eksik) => eksikler.has(eksik));
}
/**
 * Maliyet özeti YALNIZ kişi eksenli *kayıt yok* kalemi olan iki ailede
 * gösterilir. Ekipman ailesinin *kontrol tarihi bilinmiyor* kalemi KAPI kalır
 * (veri hijyeni — K-248), yüklenici ailesinin cevabı evraktır.
 */
exports.PTW_MALIYET_AILELERI = ['egitim', 'saglik'];
exports.ptwMaliyetAilesiSchema = zod_1.z.enum(exports.PTW_MALIYET_AILELERI);
function ptwMaliyetAilesiMi(aile) {
    return exports.PTW_MALIYET_AILELERI.includes(aile);
}
/**
 * MALİYET ÖZETİ — açma anında hesaplanır, KAYDEDİLMEZ. `workplaceId` null =
 * holding hücresi (tüm aktif işyerleri). `calisanSayisi` aktif ana firma
 * çalışanıdır (`isyeriCalisaniKosulu`).
 */
exports.ptwAileMaliyetiSchema = zod_1.z.object({
    aile: exports.ptwMaliyetAilesiSchema,
    workplaceId: zod_1.z.uuid().nullable(),
    calisanSayisi: zod_1.z.number().int().nonnegative(),
    kayitYok: zod_1.z.number().int().nonnegative(),
    suresiDolmus: zod_1.z.number().int().nonnegative(),
});
const KAYIT_YOK_METNI = {
    egitim: 'temel İSG kaydı yok',
    saglik: 'sağlık kaydı yok',
};
/** Özetin tek cümlesi — ekran ile test AYNI metni okur. */
function aileMaliyetMetni(ozet, turAd) {
    return (`${ptw_kontrol_matrisi_1.PTW_KONTROL_AILESI_BASLIGI[ozet.aile]} ailesini "${turAd}" türünde açarsan: ` +
        `${ozet.kayitYok} kişide ${KAYIT_YOK_METNI[ozet.aile]}, ${ozet.suresiDolmus} kişide süresi dolmuş`);
}
//# sourceMappingURL=kisi-eksik.js.map